module.exports = __webpack_public_path__ + "static/media/order_ds.30340dbd.ico";